<template>
  <div v-if="visible" class="pay-modal" @click.self="close">
    <div class="pay-modal__panel" role="dialog" aria-modal="true" aria-label="扫码支付">
      <button type="button" class="pay-modal__close" @click="close">×</button>

      <template v-if="orderNo">
        <h3 class="pay-modal__heading">订单创建成功</h3>
        <p class="pay-modal__desc">请在24小时内完成支付</p>
        <p class="pay-modal__order-no">订单号：{{ orderNo }}</p>
        <p v-if="payAmountText" class="pay-modal__amount">本次支付 ¥{{ payAmountText }}</p>
      </template>
      <h3 v-else class="pay-modal__title">请使用微信或支付宝扫码支付</h3>

      <canvas ref="qrCanvas" class="pay-modal__canvas" />
      <p class="pay-modal__scan-tip">请使用微信或支付宝扫码支付</p>

      <button type="button" class="pay-modal__btn pay-modal__btn--primary" @click="$emit('check')">
        支付完成
      </button>
      <button type="button" class="pay-modal__btn" @click="$emit('later')">
        稍后支付
      </button>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import { PAY_QR_CANVAS_SIZE } from '@/constants/auth'

export default {
  name: 'PaymentQrModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    qrUrl: {
      type: String,
      default: ''
    },
    orderNo: {
      type: String,
      default: ''
    },
    payAmount: {
      type: [Number, String],
      default: null
    }
  },
  computed: {
    payAmountText() {
      if (this.payAmount == null || this.payAmount === '') return ''
      const value = Number(this.payAmount)
      if (!value || value <= 0) return '0'
      return Math.round(value).toLocaleString('zh-CN')
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(value) {
        if (value && this.qrUrl) {
          this.$nextTick(() => {
            this.renderQrCode()
          })
        }
      }
    },
    qrUrl() {
      if (this.visible) {
        this.$nextTick(() => {
          this.renderQrCode()
        })
      }
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    renderQrCode() {
      const canvas = this.$refs.qrCanvas
      if (!canvas || !this.qrUrl) return

      QRCode.toCanvas(canvas, this.qrUrl, {
        width: PAY_QR_CANVAS_SIZE,
        margin: 2,
        color: {
          dark: '#000000',
          light: '#ffffff'
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.pay-modal {
  position: fixed;
  inset: 0;
  z-index: var(--z-index-modal);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-lg);
  background: var(--color-overlay);
}

.pay-modal__panel {
  position: relative;
  width: 100%;
  max-width: var(--modal-width-sm);
  padding: var(--space-xl);
  text-align: center;
  background: var(--color-bg-page);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-panel);
}

.pay-modal__close {
  position: absolute;
  top: var(--space-md);
  right: var(--space-md);
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: var(--color-bg-main);
  color: var(--color-text-secondary);
  font-size: 22px;
  line-height: 1;
}

.pay-modal__heading {
  margin-bottom: var(--space-sm);
  font-size: var(--font-size-lg);
  font-weight: 600;
  color: var(--color-text-primary);
}

.pay-modal__desc,
.pay-modal__order-no,
.pay-modal__amount,
.pay-modal__scan-tip {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  line-height: 1.8;
}

.pay-modal__amount {
  margin-bottom: var(--space-md);
  color: var(--color-price);
  font-weight: 600;
}

.pay-modal__title {
  margin-bottom: var(--space-lg);
  font-size: var(--font-size-md);
  color: var(--color-text-primary);
}

.pay-modal__canvas {
  display: block;
  margin: var(--space-md) auto 0;
}

.pay-modal__scan-tip {
  margin-top: var(--space-md);
}

.pay-modal__btn {
  display: block;
  width: 100%;
  margin-top: var(--space-md);
  padding: var(--space-sm) var(--space-xl);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-pill);
  background: var(--color-bg-page);
  color: var(--color-text-secondary);
  font-size: var(--font-size-md);
}

.pay-modal__btn--primary {
  border-color: var(--color-price);
  background: var(--color-price);
  color: var(--color-text-inverse);
}
</style>
